// import vm from '@/main'
import { AGORA_APPID } from '@/assets/js/const'

const AgoraRTC = window.AgoraRTC
const AgoraRTS = window.AgoraRTS
export class agoraRTC {
  constructor() {
    this.param = {
      mode: 'live',
      codec: 'vp8',
      // codec: 'h264',
      token: null,
      channel: '',
      uid: null,
      on: () => {
        console.log('回调事件')
      }
    }
    this.client = window.__agoraClient || null
    this.subscribedStreams = {}
    this.remoteStreams = {}
  }

  async init(param = {}) {

    if( !AgoraRTS.checkSystemRequirements() ){
      // 判断当前浏览器是否支持RTS
      console.log('您的浏览器不支持 RTS 和 RTC!')
      this.on({
          name: 'agoraCantUse'
      });
      return
    }
    
    // 扩展参数
    this.param = { ...this.param, ...param }
    const { mode, codec } = this.param

    // 上传日志，排错
    AgoraRTC.Logger.enableLogUpload()

    const res = await this.reInit({ mode, codec })

    // 初始化声网
    this.initClient(res)
      .then(() => {
        return this.joinClient(this.param)
      })
      .then(() => {
        console.log('join Agora Channel Success.')
        // vm.$log.info('join Agora Channel Success.')
      })
      .catch((err) => {
        this.on({
          name: 'error',
          param: err
        })
        // vm.$log.error(err)
      })
  }

  async reInit(param = {}) {
    return new Promise(async (resolve) => {
      console.log('client:::', this.client, Boolean(this.client))
      const hasClient = Boolean(this.client)
      if (!hasClient) {
        // 创建Client
        this.client = AgoraRTC.createClient({ ...param })
        window.__agoraClient = this.client;
        
        if( !AgoraRTC.checkSystemRequirements() &&  AgoraRTS.checkSystemRequirements() ){
            // 加载解码器
            AgoraRTS.init(AgoraRTC, {
                wasmDecoderPath:
            'https://fr-static.shopshops.top/static/js/agora/3.1.1/AgoraRTS.wasm',
                asmDecoderPath:
            'https://fr-static.shopshops.top/static/js/agora/3.1.1/AgoraRTS.asm',
                bufferDelay: 5000, // 直播模式下为了保证流畅度，拉大延迟到 5s
                maxBufferDelay: 10000
            }).catch((e) => {
                if (e === 'LOAD_DECODER_FAILED') {
                    console.log('加载解码器失败！')
                }
            })
            AgoraRTS.proxy(this.client)
        }

        this.client.enableAudioVolumeIndicator()
      }

      // 注册事件监听
      this.subscribeEvents()

      if (hasClient) {
        resolve(true)
        return
      }
      resolve()
    })
  }

  initClient(flag) {
    return new Promise((resolve, reject) => {
      if (flag) {
        resolve()
      }
      // 初始化声网 声网appID
      this.client.init(
        AGORA_APPID,
        () => {
          // 设置用户角色
          this.client.setClientRole('audience')
          resolve()
        },
        (err) => reject(err)
      )
    })
  }

  /**
   * 加入声网直播间 获取流地址
   * @param token
   * @param channel
   * @param uid
   * @return {Promise}
   */
  joinClient({ token, channel, uid } = {}) {
    return new Promise((resolve, reject) => {
      if (!channel) {
        reject('channel不能为空')
      } else {
        this.client.join(
          token,
          channel,
          uid,
          () => resolve(uid),
          (err) => reject(err)
        )
      }
    })
  }

  /**
   * 离开频道
   */
  leave() {
    return new Promise((resolve, reject) => {
      this.client.leave(
        () => {
          // 取消事件监听
          this.unSubscribeEvents()
          // vm.$log.info('client leaves channel success')
          resolve()
        },
        (err) => {
          // vm.$log.error('channel leave failed ', err)
          reject(reject)
        }
      )
    })
  }

  /**
   * 事件通知
   * @param param
   */
  on(param) {
    this.param.on(param)
  }

  /**
   * 注册事件监听
   */
  subscribeEvents() {
    this.client.on('stream-type-changed', (e) => {
      console.log('stream-type-changed', e)
    })

    this.client.on('stream-subscribed', (e) => {
      const { stream } = e
      this.subscribedStreams[stream.getId()] = stream
      this.on({
        name: 'playStream',
        param: {
          stream
        }
      })
      // vm.$log.info('订阅成功')
      console.log('hasAudio', stream.hasAudio())
      console.log('hasVideo', stream.hasVideo())
      // stream.on("player-status-change", e => {
      //     if (e.isErrorState && e.status === "paused"){
      //         log(`Stream is paused unexpectedly. Trying to resume...`);
      //         stream
      //             .resume()
      //             .then(() => console.log(`Stream is resumed successfully`))
      //             .catch(e => console.error(`Failed to resume stream. Error ${e.name} Reason ${e.message}`))
      //     }
      // });
    })

    this.client.on('peer-leave', (e) => {
      const { uid: id } = e
      this.unsubscribe(id, true)
    })

    this.client.on('stream-added', (e) => {
      const { stream } = e
      // vm.$log.info('event:已添加远端音视频流')
      this.remoteStreams[stream.getId()] = stream
      // 订阅流
      this.client.subscribe(stream, { video: true, audio: true }, (err) => {
        console.error('stream subscribe failed', err)
      })
    })

    this.client.on('stream-removed', (e) => {
      // vm.$log.info('event:删除远端音视频流', e)
      const { stream } = e
      const { id } = stream
      this.unsubscribe(id, true)
      this.on({ name: 'streamRemoved' })
    })

    this.client.on('error', (err) => {
      // vm.$log.error(`error: ${err.code}, reason: ${err.reason}`, 'error')
      this.on({
        name: 'error',
        param: err
      })
    })
  }

  /**
   * @author Blurain
   * @description 取消事件绑定
   */

  unSubscribeEvents() {
    this.client.off('stream-type-changed')
    this.client.off('stream-subscribed')
    this.client.off('peer-leave')
    this.client.off('stream-added')
    this.client.off('stream-removed')
    this.client.off('error')
  }

  unsubscribe(id) {
    const stream = this.subscribedStreams[id]
    if (!stream) return
    this.client.unsubscribe(stream)
    delete this.remoteStreams[id]
    delete this.subscribedStreams[id]
  }
}
